export function hexToRgb(hex) {
    if (!hex) {
        return hex;
    }
    if (hex.startsWith('rgb')) {
        return hex;
    }
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const parsedHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(parsedHex);
    if (!result) {
        console.log(`Unabled to convert hex to rgb ${hex}`);
        return undefined;
    }
    return `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`;
}
export function stringToRgb(value) {
    if (!value) {
        return value;
    }
    if (value.startsWith('rgba')) {
        return value;
    }
    if (value.startsWith('#')) {
        value = hexToRgb(value);
    }
    value = value.replaceAll('rgb(', 'rgba(');
    value = value.replaceAll(')', ', 1)');
    return value;
}
